export default () => {
  const initializeCarousel = ($carousel) => $carousel.owlCarousel({ items: 1, nav: true, navText: ['', ''] });

  $('.owl-carousel.card-carousel').each((carouselIndex, carousel) => {
    const $carousel = $(carousel);

    $(window).on('resize', () => {
      if ($(window).width() < 840 && !$carousel.hasClass('owl-loaded')) {
        initializeCarousel($carousel);
      }
      else if ($(window).width() >= 840 && $carousel.hasClass('owl-loaded')) {
        $carousel.trigger('destroy.owl.carousel');
      }
    });
  });
};
